import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment";
import { FileUploadForm } from "../new-intake/models/file-form.model";

@Injectable({
	providedIn: "root",
})
export class FileUploadService {
	private imageServiceUrl = environment.BACKEND_URL + "/refresh-sas?code=" + environment.MASTER_CODE;

	constructor(private http: HttpClient) {}

    async refreshTokens(
        fields: Array<{ data: FileUploadForm[]; key: string; parent?: any }>
    ): Promise<void> {
        const refreshPromises = fields.map(async (field) => {
            if (!field.data?.[0]?.url || field.data?.[0]?.storage === 'azure') return;
            try {
                const newUrl = await firstValueFrom(
                    this.http.post<{url: string}>(
                        this.imageServiceUrl, {url: field.data[0].url}
                    )
                );
                field.data[0].url = newUrl.url;
            } catch (error) {
                console.error(`Error refreshing ${field.key}:`, error);
            }
        });

        await Promise.all(refreshPromises);
    }
}
